import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .8,
			y: 1.05,
			width: 18.4,
			height: 18.4,
			rx: 9.2,
			fill: "#FFE1E1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .8,
			y: 1.05,
			width: 18.4,
			height: 18.4,
			rx: 9.2,
			stroke: "#C11414",
			strokeWidth: 1.6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 14.9161V14.8701M10 5.58301V11.7155",
			stroke: "#C11414",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFail;
